import { loginThirdPartyAPI } from "@/api/auth";
import { STORAGE_KEYS } from "@/lib/constants";
import { useUserStore } from "@/store/user";
import { addToast, Spinner } from "@heroui/react";
import { createFileRoute } from "@tanstack/react-router";
import { X } from "lucide-react";
import { useEffect } from "react";
import { z } from "zod";

export const Route = createFileRoute("/kakao-redirect")({
  component: RouteComponent,
  validateSearch: z.object({
    code: z.string(),
    error: z.string().optional(),
    state: z.string().optional(),
  }),
});

function RouteComponent() {
  const { code, error, state } = Route.useSearch();
  const navigate = Route.useNavigate();
  const { setUser } = useUserStore();

  const handleKakaoLogin = async () => {
    try {
      const { data } = await loginThirdPartyAPI({
        token: code,
        provider: "KAKAO",
        redirectUri: `${import.meta.env.VITE_APP_BASE_URL}/kakao-redirect`,
      });
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken);
      setUser(data?.userInfo);
      navigate({ to: "/dashboard" });
    } catch (error: any) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.clone().json();
        addToast({
          title: "로그인 실패",
          description: errorJson?.reason,
          icon: <X className="text-danger" />,
        });
        navigate({ to: "/" });
      }
    }
  };

  useEffect(() => {
    handleKakaoLogin();
  }, []);

  return (
    <div className="h-screen flex flex-col items-center justify-center gap-4">
      <Spinner />
      <h1 className="text-2xl font-bold">로그인 중입니다...</h1>
    </div>
  );
}
